import { OAuthSamlCallbackKey } from '@common/oAuth/constants';
import { navigateAndRefresh } from '@prophecy/utils/history';
import { useSearchParams } from 'react-router-dom';

import { returnFromSsoAutoLogin } from './returnFromSsoAutoLogin';

export default function OAuthSamlCallback() {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success');
  const code = searchParams.get('code');

  if (window.opener) {
    window.opener.window.postMessage({ type: OAuthSamlCallbackKey, payload: { code, success } }, '*');
    navigateAndRefresh('/');
  } else {
    returnFromSsoAutoLogin();
  }

  return null;
}
